// extracted by mini-css-extract-plugin
export var md = "_5h-4";
export var semantic = "_5h-5";
export var sm = "_5h-3";
export var text = "_5h-6";
export var toggleInput = "_5h-0";
export var toggleSwitch = "_5h-1";
export var xs = "_5h-2";